import React from 'react';
import _ from 'lodash';
import { ITaxonomy } from '../../../models/interfaces/ITaxonomy';
import { useHistory } from 'react-router';
import { ActivityButton, ActivityContainer } from './ActivitiesStyles';
import { resolveActivityIcon } from '../../Global/Icons/Icons';

type ActivityProps = {
	activity: ITaxonomy;
};

const Activity: React.FC<ActivityProps> = ({ activity }) => {
	const history = useHistory();
	const IconComponent = resolveActivityIcon(activity.icon_slug, activity.slug);
	const title = _.unescape(activity.title);

	const handleClick = () => {
		history.push(
			`/search-results?q=${encodeURIComponent(title.toLowerCase())}`,
		);
	};

	return (
		<ActivityButton
			type="button"
			onClick={handleClick}
			aria-label={`Search for ${title}`}>
			<ActivityContainer>
				<IconComponent />
			</ActivityContainer>
			<p>{title}</p>
		</ActivityButton>
	);
};

export default Activity;
